// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0a6b188","453":"7a5fea94","455":"1f1316ac","977":"5f07bc08"}[chunkId] + ".chunk.js";
};